module.exports = __webpack_public_path__ + "img/PRCA2_Neutrophils.f3839e0b.png";